module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle SC"
  }, [_vm._v("Three")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE PIED PIPER")]), _vm._v(" wasn’t crowded, and he easily got a spot at the bar. Will came and was about to say something, but the words stopped and his eyes flicked down to Caleb’s right hand. There were little circles of blood at the top of each bandage. He must have been squeezing the steering wheel too hard. But he couldn’t remember the act of driving here, couldn’t say what route he’d taken or how long he’d spent. The only thing he remembered was parking on New Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It’s nothing like that,” Caleb said. “So don’t go there.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I didn’t have my keys, and she was gone. I didn’t want to call a locksmith.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I hope you own and don’t rent. So she left, then? Bridget?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah,” Caleb said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Maybe this time, you wanna look at the menu?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I think I better. I’ll skip the Jameson, but a Guinness would be good.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Will handed him a menu and went to draw the beer.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("The steak held his interest for at least the first half, but after that he slowed down and worked on the Guinness, splitting his attention between the painting and the doorway. Sitting up every now and then and closing his eyes, trying to recreate in his mind the scent she carried. He didn’t know if nightshade was a flowering plant, or if its flowers bloomed at night, but the word was right. It was dark, something occulted. You might lose yourself in the shadows just looking for it. Looking for her.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Refill?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He looked up and saw his empty glass in Will’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No problem. Steak okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He nodded, then turned back to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("When Will came back and put the Guinness down, Caleb turned to him.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Last night, that girl who came in here, the one in the silent-film-star dress—you seen her before?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Will drummed his fingers on the bar top.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Last night. Girl. Silent-film-star dress. You gotta be more specific,” he said. “Five hundred people came through last night. Lot of them were girls. In dresses.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“She walked in, walked out. When there were just three people in here. Right before you told me your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The bartender just looked at him and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb understood. He had cuts on his fingers and his forehead, and a pair of thin-sounding explanations. If Will didn’t want to tell him anything about one of his other customers, that was probably just good sense. He let it go.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Then let me ask you this,” Caleb said. “Absinthe. That’s legal now?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Will relaxed and moved down the bar. He came back with a deep green bottle in each hand.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Law changed five, six years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This is the real stuff? What Van Gogh and Toulouse-Lautrec drank?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The real deal, from France. Made with wormwood.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You got Berthe de Joux?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Will looked at him for a second before nodding.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Not many people ask for that one.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb pushed his plate away and put his elbows on the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Probably not.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You’ll want the French pour, I guess. That’s with a sugar cube—”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And ice water,” Caleb said, finishing for him. “There must be oils dissolved in the alcohol, and the sugar and cold water precipitate them out of solution—that’s what makes it cloudy, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You a chemist?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“When it gets cloudy like that, when you mix in the ice water, the French call that the "), _c('em', [_vm._v("louche.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What’s that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Will shrugged. He took the two bottles and put them away, then came back with the Berthe de Joux and the rest of the paraphernalia of an absinthe cocktail. He poured an ounce of absinthe into the glass and laid the slotted spoon atop it. He set the sugar cube on the spoon and handed Caleb the carafe.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("As Caleb poured, Will stood and watched.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“"), _c('em', [_vm._v("La fée verte,")]), _vm._v("” he said as the drink started to change color.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What’s that?” Caleb asked. “The "), _c('em', [_vm._v("verte")]), _vm._v(" part, what you just said.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The green fairy,” Will said. He took the carafe. “That’s what they called it, those guys. Van Gogh, his crowd.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“All that hallucination stuff, it’s not just a myth?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You’re the chemist,” Will said. “Enjoy.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb held the glass under his nose and breathed in. He closed his eyes and he could picture her perfectly. The way she’d touched the back of his neck while she breathed her thanks into his ear, her hand cool and light. The nightshade scent of her. He imagined her ivory fingers gripping the edge of a theater’s screen, her muscles trembling as she pulled herself out of a silent film and into this world. He put the glass to his lips and drank the absinthe in one slow swallow, then set the glass down and put his elbows on the bar and his head in his hands.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("At midnight he walked out of the Palace Hotel and stood looking at the red neon sign: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOUSE OF SHIELDS")]), _vm._v(". When the letters flickered, there was a low buzz. An empty paper cup blew down the middle of the street, rolling in tumbling, uneven arcs. There was a black SUV parked next to a fire hydrant ahead of him. The only other car within two blocks was his own. It didn’t surprise him at all when it began to rain.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This is pointless,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He started for the door to the bar, but it opened before he reached it. Two men came out. The older one was adjusting a gray fedora but stopped when he saw Caleb. He put out his arm to check the man behind him, who moved to block the door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The older one looked down at Caleb.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You going in?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He had gray stubble and a salt-and-pepper mustache. He looked tired, but not like he’d been drinking. He reached into his overcoat and brought out a leather badge holder. Caleb saw the golden, seven-pointed star. There was just enough light to see the words on it before the man snapped it shut and put it away.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I was. Inspector.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You a regular here?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Getting to be, maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You here last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb nodded. The detective turned to his partner.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Let me have it, Garcia.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The other man handed over a white rectangle of paper. It must have been a photograph, but Caleb couldn’t see it. The detective was holding it to his chest, to keep its surface dry.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What time were you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Midnight, till maybe past two. I’m not sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Let’s do this in the truck,” Garcia said. “C’mon, it’s raining.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Fine,” the older detective said. “We’ll do it right. You mind sitting in the car with us?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Just some questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“About last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Let’s talk in the car, like Garcia said.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What’s wrong with talking right here?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It’s raining,” Garcia said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It’s just a few questions. We’re not driving anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They walked to the black Suburban, Caleb in between the two detectives. Garcia reached into his coat again and came out with a key fob. He hit a button and the truck’s fog lights flashed as the doors unlocked. The older detective opened the rear door for Caleb.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Push over. I’ll sit next to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He slid across the bench seat and the other man got in and shut the door. Garcia got into the driver’s seat, slammed that door, and then reached up to switch on the dome light.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Better now?” the older one asked his partner.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The man next to Caleb turned and held out his hand, a business card between two of his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Inspector Kennon. Guy up front is Inspector Garcia—he grew up in L.A., doesn’t understand about weather.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb reached for the card and Kennon took in the Band-Aids that wrapped each of his fingers. Garcia was watching in the rearview mirror, his brown eyes steady on Caleb’s when they met in the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“So you walk into House of Shields around midnight, leave at maybe two a.m. That right?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What’d you drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Jameson and Guinness. Three rounds, maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Come alone or with a group?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Alone. And I left alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“From the city, or you here on business?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m from the city. What is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon ignored him.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What happened to your forehead?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Look, it’s none—I got in a fight with my girlfriend on Saturday morning. She blew up and threw a glass at me. I left the house to cool off and came down to the Palace Hotel to spend the night. Right there.” He pointed out the window, but Kennon’s eyes never moved from his face. “I came over to the bar around midnight and had some drinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What was the fight about?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Personal stuff. I don’t see what that has to do with this.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What’s this have to do with?” Kennon asked. His wire-rimmed glasses had slipped low on his nose, and he was looking over them at Caleb.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Why don’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He pulled the handle on his door and opened it a crack, so they couldn’t lock him in.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Close the door,” Garcia said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You want me to close it, you put me under arrest. You just want to ask me questions, go ahead. But the door stays open.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon just pushed up his glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Leave it,” Kennon said. “It doesn’t matter. He doesn’t want to talk, he can go.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Fine,” Garcia said. “Let him get wet.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And the hand?” Kennon said, facing Caleb again. “She do that, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Didn’t have my keys, so I punched out a window. It’s not against the law. I own the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You mind showing some ID?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb leaned to reach his back pocket. Kennon’s hand disappeared inside his overcoat but came out empty when he saw Caleb’s wallet. Caleb got his driver’s license and tossed it on the seat. Kennon took it and looked at it briefly, and then passed it up to Garcia. Garcia set it on a clipboard and started copying off the information.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That address current?” Kennon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Nice street. What do you do for a living, Mr. Maddox?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Garcia stopped writing and looked up without turning around.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I run the toxicology research lab at UCSF Medical Center.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("In the rearview mirror, Garcia’s eyes snapped over to look at Kennon’s, and then he bent back to his clipboard. The pencil made a dry scratching noise.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You a doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Not a medical one. Ph.D.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We met before?” Kennon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon was older, probably a year or two away from retirement. He’d have been a young patrol officer when Caleb was twelve. It was an easy enough calculation, and Kennon had apparently already done it, or he wouldn’t have asked. Caleb felt the absinthe in his blood, warm and alive. He wanted to take it and wrap himself in it, wanted to disappear down inside himself where there would be no questions and no answers, where the only thing was the clean burn and the memory of the woman’s lips next to his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Mr. Maddox?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t think we’ve met,” Caleb answered. “If we did, I don’t remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You’re probably right. I talk to so many people, after a while they all blend together.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Garcia reached back and handed Caleb the license. He slid it into its holder, put Kennon’s business card behind it, and then stuffed the wallet into his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("When he looked up, Kennon was holding out the rectangle of paper Garcia had given him earlier. Caleb took it and looked at the four-by-six black-and-white photograph. It was a blow-up of a driver’s license photo. A middle-aged guy in a white shirt and tie, a light gray background.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Know him?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb held the picture closer to the light.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Know him? No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“But you’ve seen him.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Maybe last night, at the other end of the bar. There was a group of men. Six, seven. A couple of them turned around, checked me out when I came in. He might’ve been one of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Checked you out how?” Kennon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Just—you hear a door open behind you, you turn around. See who’s coming. That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It bother you?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’d have done the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“If you saw any of the others he was with, could you pick them out?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Maybe if I saw pictures.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Could you describe them?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You talk to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("There was a stretch of silence and they listened to the rain hitting the metal roof. Then Kennon tapped the window with his gold wedding band. Garcia turned around.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Start the engine if you want. Get some heat going.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Garcia put the keys in the ignition and cranked the engine. He let it idle a while and then he turned on the heater. Caleb felt the warm air around his ankles. He could still taste the absinthe every time he breathed out. "), _c('em', [_vm._v("Next time,")]), _vm._v(" she had said. Like a promise.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You see him leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You been drinking tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I had dinner at the Palace Hotel. So, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You eat dinner, you have a drink,” Kennon said. “One goes with the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I didn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The guy in the photo. You see him leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t think so. I left after last call. There were still some people in there. I don’t know if he was one of them or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You talk to anybody while you were in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The bartender. To order drinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That it?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The lie came out easily, without hesitation. He didn’t understand what had happened between him and the woman in House of Shields, but he’d already decided he wasn’t going to talk about it with anyone. Especially police inspectors who wouldn’t state their business. He’d tell them everything about his fight with Bridget before he’d tell them what it had felt like to sit next to the woman, to have her whisper in his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“There’s no television in there. No music. You didn’t talk to anybody. You bring a book or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I was just sitting there.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Just drinking. Thinking about your girlfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And minding my own business. I didn’t pay much attention to anyone else—and I was pretty drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Where’d you go after that? After-hours place?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Just across the street. Back to my room.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Valet working that time of night?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t know. I wasn’t driving. I just walked across the street.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Anyone open the door for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Which door did you use?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb turned and looked out the SUV’s window at the hotel across the street. He saw the valet stand, where he’d seen the woman. When she turned around and met his stare, it was as if she’d been waiting for him.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That one,” Caleb said, pointing at the door he’d used.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You went straight up to your room?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Caleb nodded. “And I didn’t leave until noon—maid woke me up.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon looked at Garcia in the mirror for a moment, then pushed up his glasses and had another long look at Caleb’s forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Well, Mr. Maddox,” he said, finally. “Thanks for your help.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon opened the door and got out, then waited while Caleb came across the bench seat and stepped back into the rain.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Think of anything else, my number’s on the card. Office on the front, cell on the back.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon shut the door and started around the hood of the Suburban to get in next to Garcia.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Wait a sec,” Caleb said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon paused and put his hand on the hood. Garcia switched on the headlights. The beams lit up the raindrops falling onto the already wet and glistening street.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This guy in the photo, what’d he do?” Caleb asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Him? He didn’t do anything. He’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kennon reset his fedora and went to the passenger door. He climbed in and then the Suburban rolled off. Caleb stood with his hands in his pockets and watched the truck. It went a block, then paused behind his parked car for a moment, headlights on his license plate. It pulled back into the lane and took the next left without signaling.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f98a2180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c03.vue
// module id = 75
// module chunks = 0